import { supabase } from '../config/supabase';
import { parseClientRequestNotes } from './clientRequestNotes';

/** Compose driver-facing trip notes from job order notes + leg notes (strip client meta). */
export function composeTripSpecialNotes(params: {
  jobNotes?: string | null;
  legNotes?: string | null;
}): string | null {
  const order = (params.jobNotes ?? '').trim() || null;
  const leg = parseClientRequestNotes(params.legNotes).specialNotes?.trim() || null;
  const parts = [order, leg].filter(Boolean) as string[];
  if (parts.length === 0) return null;
  return parts.join('\n\n');
}

export async function fetchComposeTripNotesFromIds(
  jobId?: string | null,
  jobLegId?: string | null
): Promise<string | null> {
  let jobNotes: string | null = null;
  let legNotes: string | null = null;

  if (jobId) {
    const { data } = await supabase.from('jobs').select('notes').eq('id', jobId).maybeSingle();
    jobNotes = typeof data?.notes === 'string' ? data.notes : null;
  }
  if (jobLegId) {
    const { data } = await supabase.from('job_legs').select('notes').eq('id', jobLegId).maybeSingle();
    legNotes = typeof data?.notes === 'string' ? data.notes : null;
  }

  return composeTripSpecialNotes({ jobNotes, legNotes });
}
